// extracted by mini-css-extract-plugin
export var active = "_a0-7";
export var container = "_a0-0";
export var evenWidth = "_a0-4";
export var large = "_a0-5";
export var outlet = "_a0-8";
export var slide = "_a0-2";
export var small = "_a0-6";
export var tab = "_a0-3";
export var tabs = "_a0-1";